'use client';
import { createStyles, getSize } from '@s7/styles';

const spacings = {
    xs1: '0.5s',
    sm1: '1s',
    md1: '1s'
};
var useStyles = createStyles((theme, { spacing }, { size })=>{
    return {
        root: {
            '& > * + *': {
                marginTop: theme.fn.space(getSize({
                    size: spacing != null ? spacing : size,
                    sizes: spacings
                }))
            }
        }
    };
});

export { useStyles as default };
//# sourceMappingURL=InputRoot.styles.js.map
